<template>
  <div class="sign_canvas_container" id="app">
    <div class="canvas_box">
      <h2 class="title">{{ $t('signing.signNote') }}</h2>
      <sign-canvas class="sign-canvas" ref="SignCanvas" :options="options" v-model="value" />
      <div v-if="value">{{ $t('signing.preview') }}</div>
      <img v-if="value" class="view-image" :src="value" width="100" height="100" id="canvas" />

      <div class="sign-btns">
        <span id="clear" @click="cancel()">{{ $t('common.cancel') }}</span>
        <span id="clear" @click="canvasClear()">{{ $t('signing.clear') }}</span>
        <span id="save" @click="saveAsImg()">{{ $t('signing.save') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import SignCanvas from 'sign-canvas'
import { Toast } from 'vant'
import { uploadToAliyunOss } from '../service'

export default {
  components: { SignCanvas },
  props: {
    page: {
      type: String
    }
  },
  data() {
    return {
      value: null,
      options: {
        isDpr: false, // 是否使用dpr兼容高倍屏 [Boolean] 可选
        lastWriteSpeed: 1, // 书写速度 [Number] 可选
        lastWriteWidth: 2, // 下笔的宽度 [Number] 可选
        lineCap: 'round', // 线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square] 正方形线帽
        lineJoin: 'bevel', // 线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: 350, // canvas宽高 [Number] 可选
        canvasHeight: 370, // 高度  [Number] 可选
        isShowBorder: true, // 是否显示边框 [可选]
        bgColor: '#fff', // 背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: '#fff', // 网格颜色  [String] 可选
        writeWidth: 5, // 基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: '#101010', // 轨迹颜色  [String] 可选
        isSign: true, // 签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: 'png', // 下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
        signShow: false
      }
    }
  },
  methods: {
    uploadFile: uploadToAliyunOss().uploadFile,
    // 验证canvas画布是否为空函数
    isCanvasBlank(canvas) {
      console.log(canvas)
      var blank = document.createElement('canvas') // 系统获取一个空canvas对象
      blank.width = canvas.width
      blank.height = canvas.height
      return canvas.toDataURL() === blank.toDataURL() // 比较值相等则为空
    },
    // 调用
    // 表单非空验证
    checkEmpty() {
      var c = this.$refs.SignCanvas
      document.getElementById('canvas')
      if (this.isCanvasBlank(c)) {
        alert('请绘制草图后再上传！')
      } else {
        alert('111')
      }
    },
    /**
     * 清除画板
     */
    canvasClear() {
      this.$refs.SignCanvas.canvasClear()
    },

    /**
     * 保存图片
     */
    saveAsImg() {
      if (!this.value) {
        Toast({
          message: this.$t('signing.noSignatureToast')
        })
        return
      }
      const file = this.$refs.SignCanvas.saveAsImg()
      const ossFile = this.base64toFile(file)
      this.uploadFile(ossFile, (res) => {
        sessionStorage.setItem(this.page, res.url)
        this.cancel()
        location.reload()
      }, (err) => {
        Toast({
          message: this.$t('basicLevel.failToast')
        })
        console.error(err)
      })
    },
    // base64转file二进制
    base64toFile(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },

    /**
     * 下载图片
     */
    downloadSignImg() {
      this.$refs.SignCanvas.downloadSignImg()
    },
    // 取消
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.sign_canvas_container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.57);
}
.canvas_box {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0.1rem;
  box-sizing: border-box;
}
.title {
  padding: 20px;
  text-align: center;
}
.sign-canvas {
  display: block;
  /* margin: 20px auto;  */
}
.view-image {
  display: block;
  margin: 0 auto;
  /* margin: 20px auto; */
}
.config {
  width: 350px;
  margin: 20px auto;
}
.config .ul-config {
}
.config .ul-config .li-c {
  display: flex;
  align-items: center;
  padding: 4px 10px;
}
.config .ul-config .li-c .item-label {
  font-size: 14px;
}
.config .ul-config .li-c .item-content {
  margin-inline-start: 10px;
}
.sign-btns {
  display: flex;
  justify-content: space-between;
}
#clear,
#clear1,
#save {
  display: inline-block;
  width: 0.76rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border: 1px solid #eee;
  background: #e1e1e1;
  border-radius: 10px;
  text-align: center;
  margin: 20px auto;
  cursor: pointer;
}

#save {
  background: #378e5b;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/ESignature.vue